<template>
  <div class="row" v-if="!edit">
    <div class="name-cell">{{setupItem.name}}</div>
    <div class="value-cell">{{setupItem.value}}</div>
  </div>
  <div class="row edit" v-else>
    <v-combobox class="name-cell" v-model="setupItem.name" :placeholder="$vuetify.t('$vuetify.setup.setupitem.selecttype')" :items="options" persistent-hint></v-combobox>
    <v-text-field class="value-cell" v-model="setupItem.value" placeholder="10 psi"></v-text-field>
  </div>
</template>

<script>
  export default {
    props: ['setupItem', 'edit', 'type'],
    name: 'SetupItemCell',
    data() {
      return {}
    },
    computed: {
      nameModel: {
        get() {
          return this.setupItemName != null ? this.setupItemName : this.setupItem != null ? this.setupItem.name : '';
        },
        set(value) {
          this.setupItemName = value;
        }
      },
      valueModel: {
        get() {
          return this.setupItemValue != null ? this.setupItemValue : this.setupItem != null ? this.setupItem.value : '';
        },
        set(value) {
          this.setupItemValue = value;
        }
      },
      options() {
        switch (this.type) {
          case 'fork': {
            return ['Compression', 'Lowspeed Compression', 'Highspeed Compression', 'Rebound', 'Lowspeed Rebound', 'Highspeed Rebound', this.$vuetify.t('$vuetify.setuptype.pressure'), this.$vuetify.t('$vuetify.setuptype.spring'), 'OTT', 'Bottom out']
          }
          case 'shock': {
            return ['Compression', 'Lowspeed Compression', 'Highspeed Compression', 'Rebound', 'Lowspeed Rebound', 'Highspeed Rebound', this.$vuetify.t('$vuetify.setuptype.pressure'), this.$vuetify.t('$vuetify.setuptype.spring'), 'Bottom out']
          }
          default: {
            return [this.$vuetify.t('$vuetify.setuptype.tire_front'), this.$vuetify.t('$vuetify.setuptype.tire_rear'), this.$vuetify.t('$vuetify.setuptype.pressure_front'), this.$vuetify.t('$vuetify.setuptype.pressure_rear'), this.$vuetify.t('$vuetify.setuptype.chainring')]
          }
        }
      }
    },
    methods: {}
  }
</script>
<style scoped>
  .row {
    width: 100%;
    display: flex;
  }

  .row .name-cell {
    width: 66%;
  }

  .row .value-cell {
    width: 33%;
    text-align: right;
  }

  .row.edit .name-cell,
  .row.edit .value-cell {
    width: 50%;
  }

  .row.edit .name-cell {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SetupItemCell.vue